/**
 * Platform detection for the Capacitor native shell.
 *
 * In the browser these helpers all return false; in the native iOS or
 * Android shell isNative() returns true and the BLE / push code paths
 * route through Capacitor plugins instead of Web APIs.
 *
 * Reference:
 *   docs/superpowers/plans/2026-04-27-vibe-network-mvp.md (Chunk 7)
 */

import { Capacitor } from '@capacitor/core';

export function isNative(): boolean {
    try { return Capacitor.isNativePlatform(); }
    catch { return false; }
}

export function platform(): 'ios' | 'android' | 'web' {
    try {
        const p = Capacitor.getPlatform();
        if (p === 'ios' || p === 'android') return p;
    } catch { /* fall through */ }
    return 'web';
}

export function isPluginAvailable(name: string): boolean {
    try { return Capacitor.isPluginAvailable(name); }
    catch { return false; }
}
